import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchCase = createAsyncThunk(
    'contract/fetchCase',
    async ({ idCase }: { idCase: string }, { rejectWithValue }) => {
        try {
            const response = await getRequest({'ContractID': idCase }, 'dms-hr', 'getCase', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { case: data.Contract, idCase, fetchTime: parseToTimestamp(new Date()) };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error : any) {
            return rejectWithValue(error.message);
        }
    }
);